export default __webpack_public_path__ + "static/banner_back-e27e95e634a81676f8ac5896c2c2a632.webp";